<div fxLayout="row" class="update-login-warning">
    <mat-icon fxFlex="10" svgIcon="cc-exclamation"></mat-icon>
    <p>
        To ensure the most secure login, FusionPro has removed all social sign-ins including Apple, Google and Facebook.
        <a *ngIf="shouldShowResetLink; else noLink" routerLink="/login/forgot-password">Reset your password</a>
        <ng-template #noLink>Reset your password</ng-template>
        now if you were using one of the social sign-ins above.
    </p>
</div>
